import initialState from '../initialstate';
import {GET_ALL_CLIENTS} from '../../actions/actiontypes';

export default function getAllClientsReducer(state = initialState.allClients.data, action) {
	switch (action.type) {
		case GET_ALL_CLIENTS: {
			const clients = action.response;
			return {data: clients, excludeDelegated: action.excludeDelegated};
		}
		default:
			return state;
	}
}
